// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusiness = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.756 10.587v10.269H3.762V10.221"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.8 3.144h14.61l1.498 4.985a2.667 2.667 0 0 1-4.8 1.588 2.664 2.664 0 0 1-4.282 0 2.664 2.664 0 0 1-4.283 0 2.667 2.667 0 0 1-4.8-1.588zM4.3 8.13h15.092M17.788 17.815h-5.802v-4.937h5.802zM10.022 20.856H5.719v-7.978h4.303zM16.146 8.13l-.847-4.986M7.557 8.13l.901-4.986M11.83 8.13V3.143"
    />
  </svg>
);
export default SvgBusiness;
